import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { router } from "./routes";
import { AtualizacaoApp } from "./components/ui/AtualizacaoApp";
import "./styles/globals.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // `staleTime: 0` is the equivalent of the old `force-dynamic`: every page
      // showed fresh data on each visit.
      staleTime: 0,
      // Nice for the games — coming back to the tab shows the other person's
      // move without a manual refresh.
      refetchOnWindowFocus: true,
      // One retry covers a flaky connection; more just delays the error.
      retry: 1,
    },
  },
});

const root = document.getElementById("root");
if (!root) throw new Error("Elemento #root não encontrado.");

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      {/* App chrome, not a page: the update prompt has to reach /login too. */}
      <AtualizacaoApp />
    </QueryClientProvider>
  </StrictMode>,
);
